import { useTranslations } from 'next-intl'
import React from 'react'

const CommaFormattedInput = ({ id, name, addEstate, shortName, value, onChange, isRange, disabled, verticalRange, isHomePage }: any) => {
    const t = useTranslations('')

    return (
        <div className="mb-3">

            {(!isHomePage && !addEstate) &&
              <label htmlFor={id} className="form-label">{name}</label>
            }

            {addEstate &&
                <label htmlFor={id} className="form-label">{name}</label>
            }
            {isRange ? (
                <div className="row">
                    <div
                        className={`${verticalRange ? 'col-md-12 mb-16' : ''} ${isRange && !verticalRange ? 'col-md-6' : ''} mobile-mb-16`}>
                        <input
                            type="number"
                            className="form-control"
                            placeholder={`${t('Min')} ${shortName}`}
                            id={`${id}-min`}
                            name={`${id}-min`}
                            value={value ? value['min'] : ''}
                            onChange={(e) => onChange(e, 'min')}
                            disabled={disabled}
                        />
                    </div>
                    <div
                        className={`${verticalRange ? 'col-md-12' : ''} ${isRange && !verticalRange ? 'col-md-6' : ''}`}>
                        <input
                            type="number"
                            className="form-control"
                            placeholder={`${t('Max')} ${shortName}`}
                            id={`${id}-max`}
                            name={`${id}-max`}
                            value={value ? value['max'] : ''}
                            onChange={(e) => onChange(e, 'max')}
                            disabled={disabled}
                        />
                    </div>
                </div>
            ) : (
                <input
                    type="number"
                    className="form-control"
                    placeholder={shortName}
                    id={id}
                    name={id}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                />
            )}
        </div>
    )
};
export default CommaFormattedInput;
